// src/pages/Home.jsx
import React from 'react';
import Hero         from '../components/Hero';
import StatsBar     from '../components/StatsBar';
import About        from '../components/About';
import VisionMission from '../components/VisionMission';
import Services     from '../components/Services';
import HowItWorks   from '../components/HowItWorks';
import Testimonials from '../components/Testimonials';
import CTABanner    from '../components/CTABanner';
import Contact      from '../components/Contact';

const Home = () => (
  <main style={{ overflowX: 'hidden' }}>
    <Hero />
    {/* <StatsBar /> */}
    <About />
    <VisionMission />
    <Services />
    <HowItWorks />
    <Testimonials />
    <CTABanner />
    <Contact />
  </main>
);

export default Home;
